import React from 'react';
import { Modal } from '../../components/ui';
import { isWeddingFunction, MAX_NAME } from '../../utils/helpers';

// Mobile "Quick add": full-screen list of compact guest lines — names and
// number on top, the functions as tap chips underneath. All logic is in useQuickAdd.
export default function QuickAddMobile({ vm }) {
  const {
    quickRows, quickFunctions, quickSaving, quickProgress, filledCount, closeQuick,
    setQuickField, toggleQuickFunction, addQuickRows, removeQuickRow, saveQuick,
  } = vm.quick;

  return (
    <Modal fullScreen title="Quick add guests" onClose={closeQuick}
      footer={(
        <>
          <button type="button" className="btn light" onClick={() => addQuickRows(1)} disabled={quickSaving}>+ Line</button>
          <button type="button" className="btn primary" onClick={saveQuick} disabled={quickSaving || !filledCount}>
            {quickSaving ? `Saving ${quickProgress.done}/${quickProgress.total}…` : `Save ${filledCount || ''}`}
          </button>
        </>
      )}>
      <div className="muted" style={{ fontSize: 12, marginBottom: 8 }}>
        New lines copy the functions above. Ticking any function also ticks the Wedding.
      </div>
      <div className="quick-add-cards">
        {quickRows.map((r, i) => (
          <div key={r.key} className={'quick-add-card' + (r.error ? ' has-error' : '')}>
            <div className="quick-add-line">
              <span className="muted">{i + 1}</span>
              <input placeholder="Surname" value={r.Surname} maxLength={MAX_NAME} disabled={quickSaving}
                onChange={e => setQuickField(r.key, 'Surname', e.target.value)} />
              <input placeholder="Name *" value={r.GuestName} maxLength={MAX_NAME} disabled={quickSaving}
                onChange={e => setQuickField(r.key, 'GuestName', e.target.value)} />
              <button type="button" className="icon-btn danger" disabled={quickSaving || quickRows.length === 1}
                onClick={() => removeQuickRow(r.key)}>✕</button>
            </div>
            <input className="quick-add-mobile" type="tel" inputMode="numeric" placeholder="Mobile (optional)"
              value={r.MobileNumber} disabled={quickSaving}
              onChange={e => setQuickField(r.key, 'MobileNumber', e.target.value)} />
            <div className="chips-row">
              {quickFunctions.map(f => {
                const on = r.FunctionIds.includes(String(f.FunctionId));
                return (
                  <button key={f.FunctionId} type="button" disabled={quickSaving}
                    className={'chip-toggle' + (on ? ' on' : '')} onClick={() => toggleQuickFunction(r.key, f.FunctionId)}>
                    {on ? '✓ ' : ''}{isWeddingFunction(f) ? '💍 ' : ''}{f.FunctionName}
                  </button>
                );
              })}
            </div>
            {r.error && <div className="quick-add-error-text">⚠ {r.error}</div>}
          </div>
        ))}
      </div>
    </Modal>
  );
}
